export default __webpack_public_path__ + "static/media/img-ln-4-full-mobile.cc2fe08f.png";